// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import AnalyticsBase from '../AnalyticsBase';
import AnalyticsFilterBar from '../AnalyticsFilterBar';
import BreadcrumbNav from '../../nav/BreadcrumbNav';

import { initializeAnalytics } from '../../../state/reducer/analytics/actionCreators/initializeAnalytics';
import * as DateUtils from '../../../lib/dateUtils';
import * as LibraryState from '../../../state/reducer/library/library';
import * as AnalyticsState from '../../../state/reducer/analytics/analytics';
import * as AppState from '../../../state/reducer/app/appState';

import Console from '../../../lib/debug';

type Props = {
    dispatch: any => void
};

const PAGE_KEY = 'compliance';
export const DEFAULT_SEARCH_DATE_OFFSET = 30;

class ComplianceView extends Component<Props> {
    constructor(props: Props) {
        super(props);
        LibraryState.fetchTeams();
    }

    componentDidUpdate(prevProps: {}, prevState: {}) {
        this.loadAnalytics();
    }

    // Fetch functions involve api calls to gather data
    loadAnalytics = () => {
        const dataParams = this.getDataParams();
        this.props.dispatch(initializeAnalytics(PAGE_KEY, dataParams));
    };

    setSearchParams = (params: {}) => {
        const existingParams = AnalyticsState.getSearchParams();
        AnalyticsState.updateSearchParams({
            ...existingParams,
            ...params
        });
    };

    getDataParams = () => {
        const searchParams = AnalyticsState.getSearchParams();

        let endDate = searchParams.end_date;
        if (!DateUtils.isValidDateString(endDate)) {
            endDate = moment();
            endDate = moment(endDate, DateUtils.CALENDAR_FORMAT);
        }

        let startDate = searchParams.start_date;
        if (!DateUtils.isValidDateString(startDate)) {
            startDate = moment(endDate).subtract(
                DEFAULT_SEARCH_DATE_OFFSET,
                'd'
            );
            startDate = moment(startDate, DateUtils.CALENDAR_FORMAT);
        }

        let teamIds = parseInt(searchParams.team_ids, 10);
        if (!teamIds || typeof teamIds !== 'number') {
            teamIds = [];
        } else {
            teamIds = [teamIds];
        }

        return {
            team_ids: teamIds,
            date_start: moment(startDate).format('YYYY-MM-DD'),
            date_end: moment(endDate).format('YYYY-MM-DD')
        };
    };

    getSelectedTeamId = () => {
        const params = this.getDataParams();
        if (params.team_ids.length === 1) {
            return params.team_ids[0];
        }
        return undefined;
    };

    getStartDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date_start);
    };

    getEndDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date_end);
    };

    onSelectDateRange = ({ startDate, endDate }: {}) => {
        const formattedStartDate = startDate.format(DateUtils.CALENDAR_FORMAT);
        if (!endDate) {
            this.setSearchParams({
                start_date: formattedStartDate,
                end_date: formattedStartDate
            });
            return;
        }

        this.setSearchParams({
            start_date: formattedStartDate,
            end_date: endDate.format(DateUtils.CALENDAR_FORMAT)
        });
    };

    onSelectTeam = (ev: Event, { suggestion }: any) => {
        const team_ids = suggestion.allOption === true ? [] : [suggestion.id];
        this.setSearchParams({
            team_ids
        });
    };

    getPageTitle = () => {
        let title =
            this.props.metaTree &&
            this.props.metaTree.instances &&
            this.props.metaTree.instances[PAGE_KEY] &&
            this.props.metaTree.instances[PAGE_KEY].title;
        if (title) {
            return title;
        }
        return 'Compliance';
    };

    render() {
        Console.render('ComplianceView');
        const crumbs = [
            {
                displayString: 'Analytics',
                link: `/analytics`,
                editable: false
            },
            {
                displayString: this.getPageTitle(),
                link: null,
                editable: false
            }
        ];

        return (
            <div className="has-filter-bar">
                <BreadcrumbNav crumbs={crumbs} />
                <AnalyticsFilterBar
                    dateRangePicker={{
                        startDate: this.getStartDate(),
                        endDate: this.getEndDate(),
                        onChange: this.onSelectDateRange
                    }}
                    teamSelector={{
                        selectedId: this.getSelectedTeamId(),
                        onSelect: this.onSelectTeam,
                        allOptionText: 'All Athletes'
                    }}
                />
                <AnalyticsBase />;
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        teams: state.library.teamsTree,
        metaTree: state.analytics.metaTree
    };
};

export default connect(mapStateToProps)(ComplianceView);



// WEBPACK FOOTER //
// ./src/view/analytics/compliance/ComplianceView.jsx